import Vue from "vue";


Vue.component("treeview-row", {
	props: ["value", "showNew"],
	data() {
		return {
			props: this.value
		}
	},
	
	template: `
	<div  class="entity-row mt-1" >
                        
						    <div class="entity-row-reference-number" :class=" { 
                                'has-linethrough': props.model.changeType == 'Deleted'
                            }" v-if="!showNew" v-html="props.model.referenceNumberDisplayName"></div>
						    <div class="entity-row-reference-number" :class=" { 
                                'has-linethrough': props.model.changeType == 'Deleted'
                            }" v-if="showNew" v-html="props.model.cleanReferenceNumberDisplayName"></div>
						
						
                                <div v-if="!showNew" :class="{'has-text-weight-bold': props.model.highlightTitle, 'has-linethrough': props.model.changeType == 'Deleted'}" v-html="$options.filters.decodeHTMLEntity($options.filters.stripParagraphTags(props.model.displayName))"> </div>
						        <div v-if="showNew"  :class="{'has-text-weight-bold': props.model.highlightTitle, 'has-linethrough': props.model.changeType == 'Deleted'}" v-html="$options.filters.decodeHTMLEntity($options.filters.stripParagraphTags(props.model.cleanDisplayName))"></div>
                                <span class="icon-text" v-if="props.model.changeType == 'Added'">
                                    <span class="icon">
                                     <i class="fa fa-plus"></i>
                                    </span>
                                </span>
                                <span class="icon-text" v-if="props.model.changeType == 'Deleted'">
                                    <span class="icon">
                                     <i class="fa fa-trash"></i>
                                    </span>
                                </span>
					    </div>
                      
	`
});